module.exports = __webpack_public_path__ + "static/media/r41.f4a269ee.jpg";